module.exports = "/assets/data/8ed027b93c0e4d9ad64912302ef53580-SK10.data.json";